import { graphql, useStaticQuery } from "gatsby";
import { Layout } from "@greythr/shared-components";

const LayoutWrapper = (props) => {
  const { newFeatureMenuItem, menuPromoData } = useStaticQuery(graphql`
    query LayoutData {
      newFeatureMenuItem: allDatoCmsHomePage {
        nodes {
          newFeatureMenuItem {
            url
            label
          }
          region
        }
      }
      menuPromoData: allDatoCmsMenuPromoSection(
        filter: { isCurrent: { eq: true } }
      ) {
        nodes {
          menu
          region
          title
          url
          description
          image {
            alt
            gatsbyImageData(
              width: 213
              layout: CONSTRAINED
              placeholder: BLURRED
            )
          }
          linkText
        }
      }
    }
  `);

  return (
    <Layout
      {...props}
      newFeatureMenuItem={newFeatureMenuItem}
      menuPromoData={menuPromoData}
    />
  );
};

export default LayoutWrapper;
